export const SERVICE_NAME = 'web-platform'
